import { pluck } from 'shared/utils/pluck.js';
import { getTriggerStepTemplate, getManualTriggerStepTemplate, getFunctionTriggerStepTemplate } from './stepTemplates';

const buildTriggerStep = ({ timeMachine, triggerStep, invokedBy, manualUser, manualUserId }) => {
  if (invokedBy?.startsWith('manual-')) {
    return getManualTriggerStepTemplate({ timeMachine, manualUser, manualUserId });
  }

  if (triggerStep?.appSlug === 'function') {
    const stepWithResponse = {
      ...triggerStep,
      response: { data: [{ ...pluck(triggerStep, ['stepId', 'workflowName']) }], success: true }
    };
    return getFunctionTriggerStepTemplate({ timeMachine, step: stepWithResponse });
  }

  if (triggerStep?.response?.data) {
    return getTriggerStepTemplate({ timeMachine, step: triggerStep });
  }

  return null;
};

export default buildTriggerStep;
